import React, { PropsWithChildren } from 'react'
import { AgreementProvider } from '../AgreementProvider'
import { Layout } from './Layout'
import { useProps } from './useProps'

export const Component = ({ children }: PropsWithChildren) => {
  return <Layout {...useProps()}>{children}</Layout>
}

export const RequiredAuthProvider = ({ children }: PropsWithChildren<{ skipMetamaskCheck?: boolean }>) => (
  <AgreementProvider>
    <Component>{children}</Component>
  </AgreementProvider>
)
